<template>
  <div class="hero-slider" :class="{'has-slides': infoBanner.length > 1}">
    <swiper
      ref="infoBannerSwiper"
      :options="swiperOptions"
    >
      <swiper-slide
        class="slide-item"
        v-for="(item, idx) in infoBanner"
        :key="idx"
      >
        <a
          :href="item.url"
          :target="!!item.url ? setTarget(item.url) : ''"
          :class="{'no-link': !item.url}"
        >
          <img class="slider-banner__img" :src="item.img_url" :alt="item.memo" @load="onTopImageLoaded(idx)">
        </a>
      </swiper-slide>
    </swiper>
    <template v-if="infoBanner.length > 1">
      <div class="swiper-button-prev">
        <arrow-icon width="22" color="#fff" direction="left" />
      </div>
      <div class="swiper-button-next">
        <arrow-icon width="22" color="#fff" direction="right" />
      </div>
      <div class="swiper-pagination"></div>
    </template>

    <div class="bottom-slider" v-if="!!bottomSlider && bottomSlider.length > 0">
      <swiper ref="bottomSlider" :options="bottomSwiperOptions">
       <swiper-slide
         class="bottom-slide-item"
         v-for="(item, idx) in bottomSlider"
         :key="idx"
       >
         <a
           :href="item.url"
           :target="!!item.is_external && +item.is_external === 1 ? '_blank': ''"
           :class="{'no-link': !item.url}"
         >
           <img class="item-image" :src="item.thumb" :alt="item.title">
           <!-- <img class="item-price" src="/static/img/toppage/herobottom/herobtm_price.png" alt="">-->
         </a>
       </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ArrowIcon from '@/utvStore/components/common/icon/ArrowIcon'

export default {
  name: 'HeroSlider',
  components: {
    swiper,
    swiperSlide,
    ArrowIcon,
  },
  props: {
    infoBanner: {
      type: Array,
      default() {
        return []
      }
    },
    bottomSlider: {

    },
  },
  computed: {
    swiperOptions() {
      return {
        autoplay: this.infoBanner.length > 1 ? {delay: 3000} : false,
        autoHeight: true,
        // spaceBetween: -20,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        allowTouchMove: this.infoBanner.length > 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      }
    },
    bottomSwiperOptions() {
      return {
        autoplay: {delay: 3000},
        // autoHeight: true,
        // spaceBetween: -20,
        slidesPerView: 3,
        spaceBetween: 0,
        // centeredSlides: true,
        // loop: true,
        // allowTouchMove: this.infoBanner.length > 1,
      }
    },
  },
  mounted() {
  },
  methods: {
    /**
     * 内部リンク・外部リンクを判定
     * （外部リンクなら target="_blank" となる様にする）
     */
    setTarget (url) {
      // urlと同じドメイン
      if (url.indexOf(window.location.hostname) !== -1) {
        return ''
        // 先頭が http(s):// 始まりではない
      } else if (/^(https?:\/\/)/.test(url) === false) {
        return ''
        // それ以外は外部リンク
      } else {
        return '_blank'
      }
    },
    onTopImageLoaded(idx) {
      if(idx === 0) {
        gtag('event', 'imp', {
          'event_category': 'TV-top-subsc-top',
          // 'event_label': tagId
        })
      }
    }
  }
}</script>

<style scoped lang="scss">
.hero-slider {
  padding: 0 0 12px;
  position: relative;
  &.has-slides {
    padding: 0 0 24px;
  }
  .slide-item {
    a {
      width: 100%;
      display: block;
      padding: 20px 20px 16px;
      img {
        display: block;
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        height: auto;
        box-shadow: 4px 4px 4px 0 rgba(0,0,0,0.1);
      }
    }
  }

  .swiper-pagination {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 12px;
    transition: 0.3s;
    line-height: 1;
    /deep/ {
      .swiper-pagination-bullet {
        margin: 0 6px;
        background: #fff;
        opacity: 1;
      }
      .swiper-pagination-bullet-active {
        background: #aab2bd;
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    background: rgba(#656d78, 0.5);
    width: auto;
    height: auto;
    transform: translate(0, calc(-50% - 0px));
    margin: 0;
    padding: 7px;
    font-size: 0;
    border-radius: 100px;
  }
  .swiper-button-prev { left: 5px;}
  .swiper-button-next { right: 5px;}
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    opacity: 0;
  }
}

.bottom-slider {
  /deep/ .swiper-container {
    padding: 0 16px;
  }
  .bottom-slide-item {
    padding: 0 5px;
    a {
      width: 100%;
      display: block;
      img {
        width: 100%;
        display: block;
        border-radius: 10px;
        &.item-image {
          filter: drop-shadow(4px 4px 4px rgba(0, 0, 0, 0.1));
          margin-bottom: 8px;
        }
        &.item-price {
          width: 90%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/section/HeroSlider.vue